import { menuActions } from "../_constants/actionConstants";
import { DOCTYPE } from "../_constants/docTypeConstants";
import { menuTypes } from "../_constants/menuTypes";

export const buildMainMenu_transpoEngineer =
  (assignedProjects) => (dispatch, getState) => {
    dispatch({ type: menuActions.BUILD_MENU });
    const user = getState().authentication.user;
    //set default to show latest 3 assigned projects by projectId
    let userSpecific = assignedProjects.slice(-3).map((p, index) => ({
      menuId: "u_" + index + ".0", // ex. u_0.0, u_1.0...
      projectId: p.projectId,
      type: menuTypes.MENU_PARENT,
      preIcon: "project-diagram",
      label: p.fullEA,
      link: "",
      isNew: p.isNew,
      children: [
        {
          menuId: "u_" + index + ".1",
          projectId: p.projectId,
          type: menuTypes.MENU_OPTION_CHILD,
          label: "Assistant RE/SR Daily Reports",
          link: "",
          docType: DOCTYPE.ADR_LIST,
          postIconActions: ["CREATE_ADR"],
          isDisabled: false,
        },
        {
          menuId: "u_" + index + ".2",
          projectId: p.projectId,
          type: menuTypes.MENU_OPTION_CHILD,
          label: "Weekly Newsletters",
          link: "",
          docType: DOCTYPE.WEEKLY_NEWSLETTER,
          postIconActions: ["CREATE_WEEKLY_NEWSLETTER", "COPY_WEEKLY_NEWSLETTERS"],
          isDisabled: true,
        },
        {
          menuId: "u_" + index + ".3",
          projectId: p.projectId,
          type: menuTypes.MENU_OPTION_CHILD,
          label: "Progress Payments",
          link: "",
          docType: DOCTYPE.PROGRESS_PAYMENTS,
          postIconActions: ["CREATE_PROGRESS_PAYMENTS", "FETCH_PROGRESS_PAYMENTS"],
          isDisabled: true,
        },
        {
          menuId: "u_" + index + ".4",
          projectId: p.projectId,
          type: menuTypes.MENU_OPTION_CHILD,
          label: "Lab/Plant Requests...",
          link: "",
          docType: DOCTYPE.LABPLANT_REQUESTS,
          postIconActions: ["CREATE_LABPLANT_REQUESTS", "FETCH_LABPLANT_REQUESTS"],
          isDisabled: true,
        },
        {
          menuId: "u_" + index + ".5",
          projectId: p.projectId,
          type: menuTypes.MENU_OPTION_CHILD,
          label: "Project Dashboard",
          link: "",
          docType: DOCTYPE.PROJECT_DASH,
          postIconActions: [],
          isDisabled: false,
        },
      ],
    }));
    if (userSpecific.length > 0) {
      userSpecific.push({
        menuId: "u_" + userSpecific.length + ".0",
        projectId: 0,
        type: menuTypes.MENU_OPTION_ROOT,
        preIcon: "grip-horizontal",
        label: "See All My Projects...",
        link: "",
        docType: DOCTYPE.PROJECT_LIST,
        actions: [],
        isDisabled: false,
      });
    }

    // For DES users, show QMS link
    if (user.unit.district === 59) {
      userSpecific = [
        ...userSpecific,
         {
          menuId: "u_qms_separator",
          projectId: 0,
          type: menuTypes.MENU_SEPARATOR,
          preIcon: "",
          label: "",
          link: "",
          docType: "DOCTYPE.LINK",
          actions: [],
          isDisabled: false,
        },
        {
          menuId: "u_qms",
          projectId: 0,
          type: menuTypes.MENU_OPTION_ROOT,
          preIcon: "chess-rook",
          label: "Quality Management System",
          link: "",
          docType: DOCTYPE.QMS_DASHBOARD,
          actions: [],
          isDisabled: false,
        },
      ];
    }

    dispatch({
      type: menuActions.BUILD_MENU_SUCCESS,
      payload: userSpecific,
    });
  };

export const buildMainMenu_senior = () => (dispatch, getState) => {
  dispatch({ type: menuActions.BUILD_MENU });
  const user = getState().authentication.user;

  /** @type {MenuOption} @constant userSpecific */
  const userSpecific = [
    {
      menuId: "u_2.0",
      projectId: 0,
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "user-tag",
      label: "Project Assignments",
      link: "",
      docType: DOCTYPE.PROJECT_ASSIGNMENT,
      actions: [],
      isDisabled: false,
    },
  ];

  // For DES users, show QMS link
  if (user.unit.district === 59) {
    userSpecific = [
      ...userSpecific,
      {
        menuId: "u_qms_separator",
        projectId: 0,
        type: menuTypes.MENU_SEPARATOR,
        preIcon: "",
        label: "",
        link: "",
        docType: "DOCTYPE.LINK",
        actions: [],
        isDisabled: false,
      },
      {
        menuId: "u_qms",
        projectId: 0,
        type: menuTypes.MENU_OPTION_ROOT,
        preIcon: "chess-rook",
        label: "Quality Management System",
        link: "",
        docType: DOCTYPE.QMS_DASHBOARD,
        actions: [],
        isDisabled: false,
      },
    ];
  }

  dispatch({ type: menuActions.BUILD_MENU_SUCCESS, payload: userSpecific });
};

export const buildMainMenu_manager = () => (dispatch, getState) => {
  dispatch({ type: menuActions.BUILD_MENU });
  const user = getState().authentication.user;

  let userSpecific = [
    {
      menuId: "u_2.0",
      projectId: 0,
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "user-tag",
      label: "Project Assignments",
      link: "",
      docType: DOCTYPE.PROJECT_ASSIGNMENT,
      actions: [],
      isDisabled: false,
    },
  ];

  // For DES users, show QMS link
  if (user.unit.district === 59) {
    userSpecific = [
      ...userSpecific,
      {
        menuId: "u_qms_separator",
        projectId: 0,
        type: menuTypes.MENU_SEPARATOR,
        preIcon: "",
        label: "",
        link: "",
        docType: "DOCTYPE.LINK",
        actions: [],
        isDisabled: false,
      },
      {
        menuId: "u_qms",
        projectId: 0,
        type: menuTypes.MENU_OPTION_ROOT,
        preIcon: "chess-rook",
        label: "Quality Management System",
        link: "",
        docType: DOCTYPE.QMS_DASHBOARD,
        actions: [],
        isDisabled: false,
      },
    ];
  }

  dispatch({ type: menuActions.BUILD_MENU_SUCCESS, payload: userSpecific });
};

export const buildMainMenu_supReSr = (assignedProjects) => (dispatch, getState) => {
  dispatch({ type: menuActions.BUILD_MENU });
  const user = getState().authentication.user;
  let userSpecific = [
    {
      menuId: "u_0.0",
      projectId: 0,
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "user-tag",
      label: "Project Assignments",
      link: "",
      docType: DOCTYPE.PROJECT_ASSIGNMENT,
      actions: [],
    },
    {
      menuId: "u_0.1",
      type: menuTypes.MENU_SEPARATOR,
      label: "",
      link: "",
      docType: DOCTYPE.LINK,
      actions: [],
    },
    ...assignedProjects
      .filter((p) => p.projectRoleClass === "CEBCERESR")
      .map((p, index) => ({
        menuId: "u_" + (index + 1) + ".0", // ex. u_1.0
        projectId: p.projectId,
        type: menuTypes.MENU_PARENT,
        preIcon: "project-diagram",
        label: p.fullEA,
        link: "",
        isNew: p.isNew,
        children: [
          {
            menuId: "u_" + (index + 1) + ".1",
            projectId: p.projectId,
            type: menuTypes.MENU_OPTION_CHILD,
            label: "Assistant RE/SR Daily Reports",
            link: "",
            docType: DOCTYPE.ADR_LIST,
            postIconActions: ["CREATE_ADR"],
            isDisabled: false,
          },
          {
            menuId: "u_" + (index + 1) + ".2",
            projectId: p.projectId,
            type: menuTypes.MENU_OPTION_CHILD,
            label: "Weekly Newsletters",
            link: "",
            docType: DOCTYPE.WEEKLY_NEWSLETTER,
            postIconActions: ["CREATE_WEEKLY_NEWSLETTER", "COPY_WEEKLY_NEWSLETTERS"],
            isDisabled: true,
          },
          {
            menuId: "u_" + (index + 1) + ".3",
            projectId: p.projectId,
            type: menuTypes.MENU_OPTION_CHILD,
            label: "Progress Payments",
            link: "",
            docType: DOCTYPE.PROGRESS_PAYMENTS,
            postIconActions: ["CREATE_PROGRESS_PAYMENTS", "FETCH_PROGRESS_PAYMENTS"],
            isDisabled: true,
          },
          {
            menuId: "u_" + (index + 1) + ".4",
            projectId: p.projectId,
            type: menuTypes.MENU_OPTION_CHILD,
            label: "Lab/Plant Requests...",
            link: "",
            docType: DOCTYPE.LABPLANT_REQUESTS,
            postIconActions: ["CREATE_LABPLANT_REQUESTS", "FETCH_LABPLANT_REQUESTS"],
            isDisabled: true,
          },
          {
            menuId: "u_" + (index + 1) + ".5",
            projectId: p.projectId,
            type: menuTypes.MENU_OPTION_CHILD,
            label: "Project Dashboard",
            link: "",
            docType: DOCTYPE.PROJECT_DASH,
            postIconActions: [],
            isDisabled: false,
          },
        ],
      })),
  ];

  // For DES users, show QMS link
  if (user.unit.district === 59) {
    userSpecific = [
      ...userSpecific,
      {
        menuId: "u_qms_separator",
        projectId: 0,
        type: menuTypes.MENU_SEPARATOR,
        preIcon: "",
        label: "",
        link: "",
        docType: "DOCTYPE.LINK",
        actions: [],
        isDisabled: false,
      },
      {
        menuId: "u_qms",
        projectId: 0,
        type: menuTypes.MENU_OPTION_ROOT,
        preIcon: "chess-rook",
        label: "Quality Management System",
        link: "",
        docType: DOCTYPE.QMS_DASHBOARD,
        actions: [],
        isDisabled: false,
      },
    ];
  }

  dispatch({
    type: menuActions.BUILD_MENU_SUCCESS,
    payload: userSpecific,
  });
};

export const buildMainMenu_officeAssociate = () => (dispatch, getState) => {
  dispatch({ type: menuActions.BUILD_MENU });
  const user = getState().authentication.user;
  let userSpecific = [
    {
      menuId: "u_1.0",
      projectId: 0,
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "user-tag",
      label: "Project Assignments",
      link: "",
      docType: DOCTYPE.PROJECT_ASSIGNMENT,
      actions: [],
      isDisabled: false,
    },
    {
      menuId: "u_2.0",
      projectId: 0,
      type: menuTypes.MENU_OPTION_ROOT,
      preIcon: "tools",
      label: "Admin Tasks",
      link: "",
      docType: DOCTYPE.ADMIN_TASKS,
      actions: [],
    },
  ];

  // For DES users, show QMS link
  if (user.unit.district === 59) {
    userSpecific = [
      ...userSpecific,
      {
        menuId: "u_qms_separator",
        projectId: 0,
        type: menuTypes.MENU_SEPARATOR,
        preIcon: "",
        label: "",
        link: "",
        docType: "DOCTYPE.LINK",
        actions: [],
        isDisabled: false,
      },
      {
        menuId: "u_qms",
        projectId: 0,
        type: menuTypes.MENU_OPTION_ROOT,
        preIcon: "chess-rook",
        label: "Quality Management System",
        link: "",
        docType: DOCTYPE.QMS_DASHBOARD,
        actions: [],
        isDisabled: false,
      },
    ];
  }

  dispatch({ type: menuActions.BUILD_MENU_SUCCESS, payload: userSpecific });
};

export const selectMenuItem = (menuId) => ({
  type: menuActions.SELECT_MENU_ITEM,
  payload: menuId,
});
